export const PAGAMENTO_INDENNIZZO = 'PAGAMENTO_INDENNIZZO';
export const PAGAMENTO_SPESE = 'PAGAMENTO_SPESE';
export const DOCUMENTI_LEGALI = 'DOCUMENTI_LEGALI';
export const PITECO_AGGREGA_METODI_PAGAMENTO_VALIDI = ['SEPA', 'BONIFICO_MANUALE', 'BE', 'BONIFICO_ESTERO_IBAN'];
// Metodi per cui è applicabile l'esito "Invio ordine di pagamento SAP" (oggi gli stessi di PITECO_AGGREGA_METODI_PAGAMENTO_VALIDI)
export const SAP_METODI_PAGAMENTO_VALIDI = ['SEPA', 'BONIFICO_MANUALE', 'BE', 'BONIFICO_ESTERO_IBAN'];
export const PITECO_DATA_ULTIMO_PAGAMENTO_METODI_VALIDI = ['SEPA', 'BONIFICO_MANUALE', 'BE', 'BONIFICO_ESTERO_IBAN', 'PAGOPA'];
